module.exports = __webpack_public_path__ + "img/comunidad.4d39a97b.jpeg";